import { Edition } from '@atlassian/touchpoint-commons-event-analytics';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'standard-trial-limit-breakers-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.STANDARD_EDITION,
};
